import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from '@angular/cdk/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { Sidenav } from '@shared/modules/sidenav/components/sidenav/sidenav.component';
import { SidenavTitle } from '@shared/modules/sidenav/directives/sidenav-title.directive';
import { SidenavContent } from '@shared/modules/sidenav/directives/sidenav-content.directive';
import { SidenavMenu } from '@shared/modules/sidenav/directives/sidenav-menu.directive';
import { SidenavButtonPrimary } from '@shared/modules/sidenav/directives/sidenav-button-primary.directive';
import { SidenavButtonSecondary } from '@shared/modules/sidenav/directives/sidenav-button-secondary.directive';

import { InlineDialogModule } from '@shared/components/inline-dialog/inline-dialog.component';
import { SidenavDirective } from '@shared/modules/sidenav/directives/sidenav.directive';
import { SidenavContainer } from '@shared/modules/sidenav/components/sidenav-container/sidenav-container.component';
import { SidenavDiscardDialog } from '@shared/modules/sidenav/directives/sidenav-discard-dialog.directive';
import { SidenavBannerDirective } from '@shared/modules/sidenav/directives/sidenav-banner.directive';

@NgModule({
  imports: [
    CommonModule,
    DialogModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    MatProgressBarModule,
    InlineDialogModule,
    MatTooltip,
  ],
  declarations: [
    Sidenav,
    SidenavTitle,
    SidenavContent,
    SidenavContainer,
    SidenavMenu,
    SidenavDirective,
    SidenavDiscardDialog,
    SidenavButtonPrimary,
    SidenavButtonSecondary,
    SidenavBannerDirective,
  ],
  exports: [
    Sidenav,
    SidenavTitle,
    SidenavContent,
    SidenavMenu,
    SidenavDirective,
    SidenavDiscardDialog,
    SidenavButtonPrimary,
    SidenavButtonSecondary,
    SidenavBannerDirective,
  ],
})
export class SidenavModule {}
